import React from 'react';
import { Box, Typography } from '@mui/material';

const TimelineItem = ({ item, isLast, config }) => {
  const {
    getDate,
    getIcon,
    getTitle,
    getDescription,
    getMetadata,
    renderActions,
    renderExtra,
    formatDate,
    layout,
    openModal,
  } = config;

  const { component: iconComponent, color } = getIcon(item);
  const title = getTitle(item);
  const description = getDescription(item);
  const metadata = getMetadata(item);
  const actions = renderActions(item);
  const context = { openModal };
  const extra = renderExtra(item, context);
  const dateValue = getDate(item);

  return (
    <Box sx={{ display: 'flex', mb: layout.itemSpacing }}>
      <Box sx={{ width: `${layout.dateWidth}px`, pr: 2, pt: 1 }}>
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ textAlign: 'right' }}>
          {dateValue ? formatDate(dateValue) : ''}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          px: 2,
        }}>
        <Box
          sx={{
            color: `${color}.main`,
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {iconComponent &&
            React.cloneElement(iconComponent, {
              fontSize: 'medium',
            })}
        </Box>
        {!isLast && (
          <Box
            sx={{
              width: layout.lineWidth,
              height: layout.lineSpacing,
              bgcolor: 'divider',
              mb: 2,
            }}
          />
        )}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0, py: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 0.5,
          }}>
          <Typography
            variant='subtitle1'
            component='div'
            sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
          {actions && <Box sx={{ ml: 2 }}>{actions}</Box>}
        </Box>

        {description && (
          <Typography variant='body2' sx={{ mb: 0.5 }}>
            {description}
          </Typography>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
          }}>
          <Box>
            {metadata.primary && (
              <Typography
                variant='caption'
                color='text.secondary'
                sx={{ display: 'block' }}>
                {metadata.primary}
              </Typography>
            )}
            {metadata.secondary && (
              <Typography
                variant='caption'
                color='text.secondary'
                sx={{ display: 'block', fontSize: '0.7rem' }}>
                {metadata.secondary}
              </Typography>
            )}
          </Box>
          {extra && <Box sx={{ ml: 2 }}>{extra}</Box>}
        </Box>
      </Box>
    </Box>
  );
};

export default TimelineItem;
